import React from "react";
import Publication from "../modules/Publication";

import { pubs } from "../data/publications";
import { projects } from "../data/projects";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";

const publications = pubs.sort((a, b) => b.year - a.year);
const papers = publications.filter((pub) => pub.attrs.includes("paper"));
const wips = publications.filter((pub) => pub.attrs.includes("wip"));
const manuscripts = publications.filter((pub) =>
    pub.attrs.includes("manuscript"),
);

const Home = () => {
    return (
        <Container fluid className="intro">
            <Row>
                <Col xs={12} md={{ offset: 4, span: 4 }} className="mb-5 pt-5 mt-3">
                    <div className="pyramid">
                        <div className="side left"></div>
                        <div className="side front"></div>
                        <div className="side right"></div>
                        <div className="side back"></div>
                    </div>
                    <h1 className="mb-4 intro-name">Jaeyoon Song</h1>
                    {/* <p>
                        <span className="text-bold">PhD Student @ MIT</span>
                        <br />
                        <span className="text-normal">
                            Human-AI Interaction
                        </span>
                    </p> */}
                    <p className="text-small">
                        I received my PhD in Information Technology from MIT, where I was fortunate to be advised by Prof. {" "}
                        <a
                            className="link-underline"
                            href="https://mitsloan.mit.edu/faculty/directory/thomas-w-malone"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Thomas W. Malone
                        </a>
                        . 
                        My background spans human-AI interaction and social computing, drawing on a range of computational methods, including 
                        controlled experimentation &nbsp;
                        <a
                            href="https://arxiv.org/abs/2505.01648"
                            target="_blank"
                            rel="noreferrer"
                        >
                            [CSCW '25]
                        </a> &nbsp;
                        <a
                            href="https://doi.org/10.1145/3313831.3376609"
                            target="_blank"
                            rel="noreferrer"
                        >
                            [CHI '20]
                        </a> &nbsp;
                        <a
                            href="/project/story"
                            target="_blank"
                            rel="noreferrer"
                        >
                            [preprint]
                        </a>,
                        statistical analysis  &nbsp;
                        <a
                            href="/project/badge"
                            target="_blank"
                            rel="noreferrer"
                        >
                            [CSCW '26]
                        </a> &nbsp;
                        <a
                            href="https://arxiv.org/pdf/2206.12390"
                            target="_blank"
                            rel="noreferrer"
                        >
                            [preprint]
                        </a>
                        , and system building &nbsp;
                        <a
                            href="https://dl.acm.org/doi/10.1145/3411764.3445776"
                            target="_blank"
                            rel="noreferrer"
                        >
                            [CHI '21]
                        </a> &nbsp;
                        <a
                            href="https://doi.org/10.1145/3637435"
                            target="_blank"
                            rel="noreferrer"
                        >
                            [CSCW '24]
                        </a> &nbsp;
                        <a
                            href="https://dl.acm.org/doi/abs/10.1145/3290607.3312865"
                            target="_blank"
                            rel="noreferrer"
                        >
                            [CHI LBW '19]
                        </a>
                        . 
                        Through my work at MIT and industry internships, I have developed practical experience in the evaluation and application of large language models.
                        <br />
                        <br />
                        
                            <a
                                href="https://www.linkedin.com/in/jyoonsong/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                Linkedin
                            </a>{" "}
                            &nbsp; | &nbsp;
                        <span className="d-none d-md-inline-block">
                        <a
                            href="https://github.com/jyoonsong"
                            target="_blank"
                            rel="noreferrer"
                        >
                            GitHub
                        </a>{" "}
                        &nbsp; | &nbsp;{" "}
                        </span>{" "}
                        <a
                            href="https://scholar.google.com/citations?user=Im7uFVIAAAAJ"
                            target="_blank"
                        >
                            Google Scholar
                        </a>{" "}
                        {/* &nbsp; | &nbsp;{" "}
                        <a
                            href={require(`../pdf/CV.pdf`)}
                            target="_blank"
                            rel="noreferrer"
                        >
                            CV
                        </a>{" "} */}
                        &nbsp; | &nbsp; jaeyoons@mit.edu
                    </p>
                </Col>

                {/* <Col xs={12} className="divider my-5">
                    <div></div>
                </Col>

                <Col xs={12} md={{ offset: 3, span: 6 }} className="px-2 my-5">
                    <div className="intro-title text-mono">
                        Selected Projects
                    </div>

                    <Publication
                        pub={manuscripts.find(
                            (manuscript) => manuscript.id === "forecasting",
                        )}
                        projects={projects}
                    />
                    <Publication
                        pub={papers.find((paper) => paper.id === "togedule")}
                        projects={projects}
                    />
                    <Publication
                        pub={manuscripts.find(
                            (manuscript) => manuscript.id === "badge",
                        )}
                        projects={projects}
                    />
                    <div className="view-all">
                        <Link to="/publications">View All Publications →</Link>
                    </div>
                </Col>

                <Col xs={12} className="divider my-5">
                    <div></div>
                </Col>

                <Col
                    xs={12}
                    md={{ offset: 3, span: 6 }}
                    className="px-2 my-5 py-5"
                >
                    <div className="intro-title text-mono">
                        Miscellaneous Facts
                    </div>
                    <div className="fun-fact">
                        I enjoy{" "}
                        <Link className="link-underline" to="/developer">
                            programming
                        </Link>{" "}
                        and{" "}
                        <Link className="link-underline" to="/designer">
                            design
                        </Link>{" "}
                        in my work and free time.
                    </div>
                </Col>

                <Col xs={12} className="divider my-5 opacity-0">
                    <div></div>
                </Col> */}
            </Row>
        </Container>
    );
};

export default Home;
